/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RemixesResponseData } from './RemixesResponseData';
import {
    RemixesResponseDataFromJSON,
    RemixesResponseDataFromJSONTyped,
    RemixesResponseDataToJSON,
} from './RemixesResponseData';

/**
 * 
 * @export
 * @interface RemixesResponse
 */
export interface RemixesResponse {
    /**
     * 
     * @type {RemixesResponseData}
     * @memberof RemixesResponse
     */
    data?: RemixesResponseData;
}

/**
 * Check if a given object implements the RemixesResponse interface.
 */
export function instanceOfRemixesResponse(value: object): value is RemixesResponse {
    let isInstance = true;

    return isInstance;
}

export function RemixesResponseFromJSON(json: any): RemixesResponse {
    return RemixesResponseFromJSONTyped(json, false);
}

export function RemixesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemixesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : RemixesResponseDataFromJSON(json['data']),
    };
}

export function RemixesResponseToJSON(value?: RemixesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': RemixesResponseDataToJSON(value.data),
    };
}

